<template>

  <div class="fullcontainer" style="position:absolute;">
    
    <div class="PicturePageConti">
      <img class="picturebg" :src="centerPicSrc"/>
    </div>

    
  </div>

</template>

<script>



export default {
  data() {
    return {};
  },
  props: {
    picName: String
  },
  computed: {
    centerPicSrc() {
      return `res/p4/${this.picName}.png`;
    }
  },

  mounted() {},

  methods: {},

  components: {}
};
</script>

<style lang="scss">

@import "D:/workspace/all_web/src/_cmm/css/horizontalCenterPercent.scss";


.picturebg {
  width: 74%;
  position: relative;
  top:0%;
}

.PicturePageConti {
  position: relative;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content:center;
}


</style>
